import { render, staticRenderFns } from "./DeductionsPlanAdd.vue?vue&type=template&id=1d0cec15&scoped=true&"
import script from "./DeductionsPlanAdd.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0cec15",
  null
  
)

export default component.exports